import React from "react";
import { useParams } from "react-router-dom"; // Get the ID from the URL
import ScrollToTop from "../../components/ScrollTop";
import Breadcrumb from "../../components/Breadcrumb";
import FooterTwo from "../../components/Footer/FooterTwo";
import Header from "../../components/Header";
import Logo from "../../assets/images/logos/logo2.png";
import { FREE_RESOURCES } from "./upsc-resources-constants";

const UpscResourcesDetails = () => {
  const { id } = useParams(); // Get ID from URL
  const resourceId = parseInt(id, 10); // Convert ID to a number
  const freeresource = FREE_RESOURCES.find((res) => res.id === resourceId); // Find matching resource

  return (
    <>
      <Header
        parentMenu="page"
        menuCategoryEnable="enable"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        topbarEnable="enable"
      />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle={freeresource.title} />

          <div className="container my-5" style={{ paddingBottom: "80px" }}>
            {freeresource ? (
              <>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Subject</th>
                      <th>Download Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    {freeresource.resource.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.subject}</td>
                        <td>
                          <a
                            href={item.downloadLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Download
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            ) : (
              <p className="text-center text-danger">Resource not found.</p>
            )}
          </div>

          {/* Scroll to Top */}
          <ScrollToTop />
        </div>
      </div>

      <FooterTwo />
    </>
  );
};

export default UpscResourcesDetails;
